import * as React from 'react';
import Typography from '@mui/material/Typography';
import Link from '@mui/material/Link';
import {Trans} from "@lingui/react/macro";

export default function Copyright(props: any) {
    return (
        <Typography variant="body2" color="text.secondary" align="center" {...props}>
            TimberStorage | <Link color="inherit" href="https://iokrono.com">IOKrono d.o.o.</Link> © {new Date().getFullYear()} | <Trans>Version</Trans>: 0.9.2 prod | 2026-03-04 13:30
        </Typography>
    );
}
